import { render, staticRenderFns } from "./ProductionList.vue?vue&type=template&id=4ec509f6&scoped=true"
import script from "./ProductionList.vue?vue&type=script&lang=js"
export * from "./ProductionList.vue?vue&type=script&lang=js"
import style0 from "./ProductionList.vue?vue&type=style&index=0&id=4ec509f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec509f6",
  null
  
)

export default component.exports